var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';








const Pill = ({ children, color = 'gray', className }) => {
  let pillColors = '';

  switch (color) {
    case 'gray':
      pillColors = 'bg-gray-100';
      break;

    case 'yellow':
    case 'green':
    case 'blue':
    case 'red':
      pillColors = `bg-${color}-100 text-${color}-800`;
      break;

    default:
      pillColors = 'bg-primary-100 text-primary-800';
      break;
  }
  return /*#__PURE__*/(
    _jsx("span", {
      className: `${className} px-2.5 py-1 rounded-md text-xs ${pillColors}`,
      "data-testid": "pill-comp" }, void 0,

    children
    ));

};


export { Pill };